import { flushSync } from 'react-dom';
import { Toast } from '@heroui/react';

/**
 * Своя очередь тостов вместо дефолтного `toast()` из HeroUI: тот по
 * умолчанию заворачивает каждое обновление в `document.startViewTransition`
 * (`wrapUpdate` в `ToastQueue`, см. исходники `@heroui/react`) — красиво, но
 * в этом приложении (шторка снизу + закрытие меню в том же клике) стабильно
 * ловит `InvalidStateError: Transition was aborted because of invalid
 * state`: браузер не успевает завершить предыдущий переход, новый рвётся.
 *
 * Просто выкинуть весь `wrapUpdate` (`(fn) => fn()`, без `flushSync`)
 * НЕДОСТАТОЧНО и ломает тосты по-другому, тише: `useToastQueue` внутри
 * `react-stately` держит видимые тосты через `useSyncExternalStore`, чьё
 * `getSnapshot` сравнивает ссылку на массив `visibleToasts` — без `flushSync`
 * обновление очереди из обработчика клика, где в этом же тике ещё и
 * размонтируется шторка (`onClose`), не гарантированно попадает в тот же
 * проход React, и `ToastRegion` иногда просто не перерисовывается, хотя сам
 * тост в очереди уже есть (`toastQueue.visibleToasts.length` растёт, а DOM
 * — нет, без единой ошибки в консоли). `flushSync` — та же синхронность,
 * что и раньше, просто без View Transitions API поверх нее.
 */
const toastQueue = new Toast.Queue({ wrapUpdate: (fn: () => void) => flushSync(fn) });

export function showToast(
  message: string,
  variant: 'default' | 'success' | 'danger' | 'accent' | 'warning' = 'default',
): string {
  return toastQueue.add({ title: message, variant }, { timeout: 4000 });
}

export { toastQueue };
